import React from 'react';
import FrenkitSearch from './FrenkitSearch'; // Importa el componente desde el archivo donde lo moviste
import { createRoot } from 'react-dom/client';
import '@fontsource/mukta-vaani/400.css';
import '@fontsource/mukta-vaani/500.css';
import './i18n';

const container = document.getElementById('frenkit-search-app');

// Leer el idioma y la referencia de los atributos data-lang y data-reference
const language = container?.getAttribute('data-lang') || 'es'; // 'es' como valor por defecto
const vehicle_type = container?.getAttribute('data-vehicle_type') as "" | "auto" | "moto" | "performance";
const country_code = container?.getAttribute('data-country_code') as "" | "eu" | "latam" | "us";
const reference = container?.getAttribute('data-reference') || '';

if (container) {
  const root = createRoot(container); // createRoot(container!) if you use TypeScript
  root.render(<FrenkitSearch language={language} vehicle_type={vehicle_type} country_code={country_code} reference={reference}/>);
}